import './NotesPanel.css';
import { NebulaButton as F, NebulaDialog as B, NebulaDropdown as O, NebulaIcon as V, NebulaPanel as $ } from "@discoveryedu/nebula-components";
import { n as I } from "./platform-components-assets/nebula_tokens-es.js";
import { H as E } from "./platform-components-assets/highlight-es.js";
import { N as z } from "./platform-components-assets/note-es.js";
import L from "./NoteComponent.js";
import { resolveComponent as m, openBlock as l, createElementBlock as u, Fragment as C, createElementVNode as a, createVNode as f, normalizeStyle as j, withCtx as p, toDisplayString as N, mergeProps as c, createBlock as r, normalizeClass as w, createCommentVNode as x, renderList as U, useCssVars as q } from "vue";
import { _ as G } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
import { t as R } from "./platform-components-assets/throttle-es.js";
const H = {
  name: "NotesPanel",
  components: {
    NebulaButton: F,
    NebulaDialog: B,
    NebulaDropdown: O,
    NebulaIcon: V,
    NoteComponent: L,
    NebulaPanel: $
  },
  computed: {
    actionBarOffsetFormatted() {
      let e = 0;
      return this.windowSize < this.smallScreenWidthThreshold ? e = `${this.actionBarOffsetSmallScreen}px` : e = `${this.actionBarOffset}px`, e;
    },
    activeNoteId() {
      var e;
      return (e = this.activeNote) == null ? void 0 : e.id;
    },
    activeNoteTextarea() {
      return this.activeNoteId ? document.getElementById(`note-text--${this.activeNoteId}`) : document.getElementById("note-text--empty-note");
    },
    filteredHighlights() {
      return this.updateCounter, this.highlightsCopy.filter((t) => {
        var i;
        return (i = t == null ? void 0 : t.note) == null ? void 0 : i.text;
      });
    },
    firstFocusItem() {
      let e = `hl-item--${this.focusedHighlight}`;
      return this.focusedHighlight === "empty" && (e = "note-text--empty-note"), this.focusedHighlight ? e : "notes-panel-first-focus-item";
    },
    hasNotes() {
      return this.filteredHighlights.length > 0;
    },
    isHidden() {
      return !this.notesPanelVisible;
    },
    modalConfirmActionText() {
      return this.deleteAllNotes ? this.$t("Delete All") : this.editMode ? this.$t("Discard Changes") : this.$t("Delete Note");
    },
    modalHeader() {
      return this.deleteAllNotes ? this.$t("Delete All Notes & Highlights?") : this.editMode ? this.$t("Discard Changes to this note?") : this.$t("Delete Note?");
    },
    modalContent() {
      return this.deleteAllNotes ? this.$t("Are you sure you want to delete ALL notes and highlights in this lesson? This action is permanent and cannot be reversed.") : this.editMode ? this.$t("Are you sure you want to discard changes to this note?") : this.$t("Are you sure you want to delete this note? This action is permanent and cannot be undone.");
    },
    notesPanelDisplay() {
      return this.notesPanelVisible ? "flex" : "none";
    },
    notebookUrl() {
      return this.notebookLinkUrl || `/learn/notebook/course/${this.courseGuid}/unit/${this.unitGuid}/concept/${this.conceptGuid}`;
    }
  },
  data() {
    var e;
    return {
      activeNote: null,
      activeNoteFocused: null,
      activeNoteText: null,
      avatarArt: "hightlight-art-6-8",
      cStatic: ((e = window.paths) == null ? void 0 : e.core_static) || "",
      deleteAllNotes: !1,
      editMode: !1,
      highlightsCopy: [],
      highlightsVisible: !0,
      notesPanelVisible: !1,
      overlayThreshold: 768,
      emptyHighlight: null,
      updateCounter: 1,
      noteLoading: !1,
      noteSaved: !1,
      smallScreenWidthThreshold: parseInt(I.tokens.breakpoints["mobile-landscape"], 10),
      windowSize: null
    };
  },
  emits: [
    "active-note-changed",
    "dialog-closed",
    "edit-canceled",
    "edit-mode",
    "note-deleted",
    "note-created",
    "note-updated",
    "note-text-changed",
    "toggle-panel",
    "highlight-color-change",
    "highlight-focused",
    "highlight-selected",
    "highlights-visible"
  ],
  watch: {
    activeNote() {
      this.$emit("active-note-changed", {
        activeNote: this.activeNote
      });
    },
    editMode(e) {
      this.$nextTick(() => {
        const { notesPanel: t } = this.$refs;
        e ? t.$props.disableClose = !0 : t.$props.disableClose = !1, this.$emit("edit-mode", e);
      });
    },
    highlights() {
      this.highlightsCopy = [...this.highlights];
    },
    highlightsVisible() {
      this.highlightsVisible || this.closePanel();
    },
    notesPanelVisible() {
      this.notesPanelVisible && !this.highlightsVisible && this.toggleNotesAndHighlights();
    }
  },
  methods: {
    createNote(e) {
      this.openPanel();
      const t = new z();
      return t.highlight = e, this.emptyHighlight = e, this.activeNote = t, this.activeNoteFocused = !0, this.editMode = !0, this.updateCounter += 1, this.$nextTick(() => {
        e.select(), this.$emit("highlight-selected", e);
      }), t;
    },
    async confirmDeleteAllHighlights() {
      await E.batchDelete(this.highlightsCopy), this.highlightsCopy.forEach((e) => {
        this.$emit("note-deleted", e.note), e.note = null;
      }), this.highlightsCopy = [], this.deleteAllNotes = !1, this.$nextTick(() => {
        this.$refs.confirmModal.closeDialog();
      });
    },
    deleteAllNotesAndHighlights() {
      if (!document.querySelectorAll("mark.de-highlight").length) {
        this.deleteAllNotes = !1;
        return;
      }
      this.deleteAllNotes = !0, this.$refs.confirmModal.showDialog();
    },
    focusNote(e) {
      this.openPanel(), this.$nextTick(() => {
        const t = document.getElementById(`hl-item--${e}`);
        t && t.focus();
      });
    },
    isNotesPanelVisible() {
      return this.notesPanelVisible;
    },
    onHighlightColorChange(e) {
      this.$emit("highlight-color-change", e);
    },
    onCancelEdit(e, t) {
      if (this.activeNote = e, this.activeNote.text === t || !t) {
        this.confirmCancel(), this.$nextTick(() => {
          var i;
          this.focusNote((i = e == null ? void 0 : e.highlight) == null ? void 0 : i.id);
        });
        return;
      }
      this.$refs.confirmModal.showDialog();
    },
    onFocusIn(e, t) {
      var s, o;
      const i = e.target.closest(".notes-panel__note"), h = this.actionBarOffset + 16;
      if (this.$emit("highlight-focused", t), this.$nextTick(() => {
        t.select(h), this.$emit("highlight-selected", t);
      }), this.activeNote !== null) {
        const { noteId: g } = i == null ? void 0 : i.dataset;
        if (this.emptyHighlight !== null) {
          this.activeNoteFocused = !!((o = (s = this.emptyHighlight) == null ? void 0 : s.note) != null && o.id), this.toggleBounceAnimation();
          return;
        }
        g && g !== this.activeNoteId && (this.activeNoteFocused = g === this.activeNoteId, this.toggleBounceAnimation());
      }
    },
    onFocusOut(e) {
      const t = e.target.closest(".notes-panel__wrapper"), { target: i, relatedTarget: h } = e, { confirmModal: s } = this.$refs, o = t.querySelector(`#hl-item--${this.activeNoteId}`);
      if (this.editMode) {
        const g = i == null ? void 0 : i.closest(".notes-panel__note"), d = h == null ? void 0 : h.closest(".notes-panel__note");
        if (t.contains(i) && t.contains(h)) {
          if (this.emptyHighlight && !this.activeNoteText) {
            this.$refs.newNoteforHighlight.handleCancel();
            return;
          }
          if (i.value && this.activeNoteText === this.activeNote.text) {
            this.reset(), o ? o.focus() : i.closest("li").focus();
            return;
          }
          if (g !== d && i.value && i.value !== this.activeNote.text) {
            this.toggleBounceAnimation();
            return;
          }
          return;
        }
        if (!t.contains(h) && !(s != null && s.$el.contains(h))) {
          if (this.emptyHighlight && !this.activeNoteText) {
            this.$refs.newNoteforHighlight.handleCancel();
            return;
          }
          if (this.activeNote && i.value === this.activeNote.text) {
            this.reset();
            return;
          }
          if (this.emptyHighlight !== null) {
            this.toggleBounceAnimation();
            return;
          }
          this.toggleBounceAnimation();
        }
      }
    },
    onNoteTextChanged(e) {
      this.activeNoteText = e, this.$emit("note-text-changed", e);
    },
    toggleBounceAnimation() {
      this.activeNoteFocused = !1;
      let e;
      this.activeNoteId ? e = document.querySelector(`.notes-panel__note[data-note-id='${this.activeNoteId}']`) : e = document.querySelector(".notes-panel__note--empty"), this.activeNote && (this.activeNoteTextarea.focus(), this.$nextTick(() => {
        const { highlight: t } = this.activeNote;
        t.select(), this.$emit("highlight-selected", t), e.classList.remove("bounce"), e.classList.add("bounce"), setTimeout(() => {
          e.classList.remove("bounce");
        }, 900);
      }));
    },
    confirmCancel() {
      this.reset(), this.$emit("edit-canceled"), this.$refs.confirmModal.closeDialog();
    },
    onEditMode(e, t) {
      this.editMode = e, t && (this.activeNote = t, this.noteSaved = !1, this.activeNoteText = t.text, this.$nextTick(() => {
        this.activeNoteFocused = this.activeNoteId === t.id, this.activeNoteTextarea.focus();
      }));
    },
    async onNoteUpdateData(e) {
      var h, s;
      const { note: t, highlight: i } = e;
      if (!i.metadata.asset_id) {
        const o = (s = (h = i.selection) == null ? void 0 : h.commonAncestor) == null ? void 0 : s.closest("[data-guid]").dataset.guid;
        i.metadata.asset_id = o;
      }
      if (i.metadata.page_id || (i.metadata.page_id = this.pageId), this.noteLoading = !0, !t.id) {
        await t.create(e, this.noteToken), this.reset(), i.injectNoteElement(t), this.$emit("note-created", t), this.$nextTick(() => {
          this.focusNote(i == null ? void 0 : i.id);
        });
        return;
      }
      t.update(t).then(() => {
        this.reset(), this.noteSaved = !0, this.$emit("note-updated", t), this.$nextTick(() => {
          this.focusNote(i == null ? void 0 : i.id);
        });
      });
    },
    cancelAction() {
      if (this.deleteAllNotes) {
        this.deleteAllNotes = !1, this.$nextTick(() => {
          this.$refs.confirmModal.closeDialog();
        });
        return;
      }
      if (!this.activeNote.id) {
        this.editMode = !0, this.$refs.confirmModal.closeDialog(), this.$nextTick(() => {
          this.activeNoteTextarea.focus();
        });
        return;
      }
      this.$refs.confirmModal.closeDialog();
    },
    onDialogClosed() {
      this.deleteAllNotes && (this.deleteAllNotes = !1), !this.editMode && !this.emptyHighlight && (this.activeNote = null), this.activeNote && (this.activeNoteTextarea.focus(), this.activeNoteFocused = this.activeNote), this.emptyHighlight && (this.editMode = !0), this.$emit("dialog-closed");
    },
    onNoteDelete(e) {
      this.activeNote = e, e.id || (this.editMode = !1, this.noteSaved = !1), this.$refs.confirmModal.showDialog();
    },
    async confirmDelete(e) {
      e.highlight === this.emptyHighlight && (this.emptyHighlight = null), e.id && await e.delete(e.id);
      const { highlight: t } = e;
      t.note = null, t.removeNoteElement(), this.reset(), this.$emit("note-deleted", e), this.$refs.confirmModal.dialogVisible && this.$refs.confirmModal.closeDialog();
    },
    modalConfirmAction(e) {
      return this.deleteAllNotes ? this.confirmDeleteAllHighlights() : this.editMode ? this.confirmCancel(e) : this.confirmDelete(e);
    },
    toggleNotesAndHighlights() {
      this.highlightsCopy.length && (this.highlightsVisible = !this.highlightsVisible, this.$emit("highlights-visible", this.highlightsVisible), this.highlightsCopy.forEach((e) => e.toggleVisibility(this.highlightsVisible)));
    },
    closePanel() {
      this.togglePanel(!1);
    },
    openPanel() {
      this.togglePanel(!0);
    },
    togglePanel(e = null) {
      let t = null;
      !this.emptyHighlight && !this.activeNoteText && !this.activeNote && (e === null ? t = !this.notesPanelVisible : t = e, this.notesPanelVisible = t, this.$emit(
        "toggle-panel",
        this.notesPanelVisible
      )), this.editMode && this.toggleBounceAnimation(), this.emptyHighlight && !this.activeNoteText && this.onNoteDelete(this.activeNote), this.emptyHighlight && this.activeNoteText && this.toggleBounceAnimation(), this.activeNoteText && this.toggleBounceAnimation();
    },
    addHighlightReference(e) {
      this.highlightsCopy.push(e), this.updateCounter += 1;
    },
    removeHighlightReference(e) {
      this.highlightsCopy = this.highlightsCopy.filter((t) => t.id !== e.id), this.updateCounter += 1;
    },
    updateHighlightReference(e) {
      const t = this.highlightsCopy.findIndex((i) => i.id === e.id);
      t !== -1 ? (this.highlightsCopy[t] = e, this.updateCounter += 1) : (this.highlightsCopy.push(e), this.updateCounter += 1);
    },
    reset() {
      this.noteLoading = !1, this.noteSaved = !1, this.editMode = !1, this.activeNoteFocused = null, this.emptyHighlight = null, this.activeNote = null, this.activeNoteText = null, this.updateCounter += 1;
    },
    setWindowSize() {
      this.windowSize = document.documentElement.clientWidth;
    }
  },
  mounted() {
    this.throttledHandleResize = R(this.setWindowSize, 150), window.addEventListener("resize", this.throttledHandleResize), this.setWindowSize();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.throttledHandleResize);
  },
  props: {
    actionBarOffset: {
      type: Number,
      default: 56
    },
    actionBarOffsetSmallScreen: {
      type: Number,
      default: 40
    },
    avatarPath: {
      type: String,
      default: null
    },
    calculatePanelHeight: {
      type: Boolean,
      default: !0
    },
    cits: {
      type: Array,
      default: () => []
    },
    conceptGuid: {
      type: String,
      required: !0
    },
    courseGuid: {
      type: String,
      required: !0
    },
    focusedHighlight: {
      type: String,
      default: null
    },
    highlights: {
      type: Array,
      default: () => []
    },
    notebookLinkUrl: {
      type: String,
      default: null
    },
    noteToken: {
      type: String,
      required: !0
    },
    pageId: {
      type: String
    },
    unitGuid: {
      type: String,
      required: !0
    },
    buttonNotebookAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonHideNotesAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonDeleteNotesAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonYellowAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonPinkAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonGreenAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonBlueAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonEditCancelAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonEditSaveAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonDeleteAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonEditAttributes: {
      type: Object,
      default: () => ({})
    }
  }
}, D = () => {
  q((e) => ({
    "2d5141d2": e.notesPanelDisplay,
    c664c80e: e.actionBarOffsetFormatted
  }));
}, T = H.setup;
H.setup = T ? (e, t) => (D(), T(e, t)) : D;
const W = { class: "notes-panel__wrapper" }, K = { class: "notes-panel__header" }, Y = { class: "notes-panel__header-start" }, J = { class: "notes-panel__title" }, Q = { class: "notes-panel__header-end" }, X = { class: "notes-panel__content" }, Z = {
  key: 0,
  class: "notes-panel__content-notes"
}, ee = { class: "notes-panel__notes-list" }, te = ["data-note-id", "data-highlight-id", "id", "onFocusin"], ie = {
  key: 1,
  class: "notes-panel__content--empty"
}, oe = ["src"], se = { class: "notes-panel__empty-heading" }, ne = { class: "notes-panel__empty-text" }, le = { class: "notes-panel__confirmation-modal-header" }, he = { class: "notes-panel__confirmation-modal-content" };
function ae(e, t, i, h, s, o) {
  const g = m("NebulaIcon"), d = m("NebulaButton"), P = m("NebulaDropdown"), A = m("NoteComponent"), S = m("NebulaPanel"), M = m("NebulaDialog");
  return l(), u(C, null, [
    a("div", W, [
      f(S, {
        "aria-label": e.$t("Notes Panel"),
        "display-on-right": !0,
        "first-focus-id": o.firstFocusItem,
        "is-open": s.notesPanelVisible,
        mobileThreshold: s.overlayThreshold,
        style: j(i.calculatePanelHeight ? {
          height: `calc(100vh - ${o.actionBarOffsetFormatted})`,
          top: o.actionBarOffsetFormatted
        } : void 0),
        onTogglePanel: o.togglePanel,
        "disable-close": s.editMode,
        class: "notes-panel",
        "panel-id": "notes-panel-1",
        ref: "notesPanel"
      }, {
        panelHeader: p(() => [
          a("div", K, [
            a("div", Y, [
              f(g, {
                symbolId: "highlight-note",
                class: "notes-panel__notes-icon",
                size: "s"
              }),
              a("h3", J, N(e.$t("My Notes")), 1)
            ]),
            a("div", Q, [
              f(d, c({
                "aria-label": e.$t("Open Noteboook in new window"),
                class: "notes-panel_icon-book",
                id: "notes-panel-first-focus-item",
                "icon-left": "book",
                link: o.notebookUrl,
                target: "_blank",
                type: "flat",
                "disabled-link": s.editMode
              }, i.buttonNotebookAttributes), null, 16, ["aria-label", "link", "disabled-link"]),
              f(P, {
                "button-id": "toggle-highlight-visibility",
                class: "notes-panel__dropdown highlights-options__dropdown",
                "content-element": "div",
                "dropdown-id": "highlights-visibility-dropdown-menu",
                "use-white-background": ""
              }, {
                trigger: p(({ toggleDropdown: n, checkArrowKeyOnTrigger: b, checkArrowKeyAfterTrigger: _, isOpen: y }) => [
                  s.editMode ? (l(), r(d, c({
                    key: 0,
                    "aria-label": e.$t("Hide or Delete Notes & Highlights Dropdown - disabled"),
                    class: "notes-panel__dropdown-button notes-panel__dropdown-button--disabled highlights-options__dropdown-button notes-panel__dropdown highlights-options__dropdown-button--disabled",
                    id: "toggle-highlight-visibility-disabled",
                    "icon-left": "ellipsis-vertical",
                    type: "flat",
                    "is-disabled": !0
                  }, i.buttonHideNotesAttributes), null, 16, ["aria-label"])) : (l(), r(d, c({
                    key: 1,
                    "aria-label": e.$t("Hide or Delete Notes & Highlights Dropdown"),
                    id: "toggle-highlight-visibility",
                    class: "notes-panel__dropdown-button highlights-options__dropdown-button",
                    "icon-left": "ellipsis-vertical",
                    "aria-expanded": y && "true" || "false",
                    "aria-haspopup": "true",
                    "aria-controls": "highlights-visibility-dropdown-menu",
                    type: "flat"
                  }, i.buttonHideNotesAttributes, {
                    onClick: n,
                    onKeydown: b,
                    onKeyup: _
                  }), null, 16, ["aria-label", "aria-expanded", "onClick", "onKeydown", "onKeyup"]))
                ]),
                content: p(() => [
                  s.highlightsCopy.length ? (l(), r(d, c({
                    key: 1,
                    class: "notes-panel__hide-highlights highlights-options__dropdown-item highlights-options__hide-highlights",
                    "icon-left": "show",
                    type: "flat",
                    size: "s",
                    text: e.$t("Hide Notes & Highlights")
                  }, i.buttonHideNotesAttributes, {
                    onClick: o.toggleNotesAndHighlights,
                    "data-click-type": "TTS Notes Panel",
                    "data-click-name": "Hide Notes & Highlights"
                  }), null, 16, ["text", "onClick"])) : (l(), r(d, c({
                    key: 0,
                    class: "notes-panel__hide-highlights notes-panel__hide-highlights--disabled highlights-options__dropdown-item highlights-options__dropdown-item--disabled",
                    "icon-left": "show",
                    type: "flat",
                    size: "s",
                    text: e.$t("Hide Notes & Highlights"),
                    "is-disabled": !0
                  }, i.buttonHideNotesAttributes), null, 16, ["text"])),
                  s.highlightsCopy.length ? (l(), r(d, c({
                    key: 3,
                    class: "notes-panel__delete-highlights highlights-options__dropdown-item highlights-options__delete-highlights",
                    "icon-left": "trash",
                    type: "flat",
                    size: "s",
                    text: e.$t("Delete All Notes & Highlights")
                  }, i.buttonDeleteNotesAttributes, {
                    onClick: o.deleteAllNotesAndHighlights,
                    "data-click-type": "TTS Notes Panel",
                    "data-click-name": "Delete All Notes & Highlights"
                  }), null, 16, ["text", "onClick"])) : (l(), r(d, c({
                    key: 2,
                    class: "notes-panel__delete-highlights notes-panel__delete-highlights--disabled highlights-options__dropdown-item highlights-options__dropdown-item--disabled",
                    "icon-left": "trash",
                    type: "flat",
                    size: "s",
                    text: e.$t("Delete All Notes & Highlights"),
                    "is-disabled": !0
                  }, i.buttonDeleteNotesAttributes), null, 16, ["text"]))
                ]),
                _: 1
              })
            ])
          ])
        ]),
        panelContent: p(() => [
          a("div", X, [
            o.hasNotes || s.emptyHighlight ? (l(), u("div", Z, [
              a("ul", ee, [
                s.emptyHighlight ? (l(), u("li", {
                  key: 0,
                  class: w(["notes-panel__note", [
                    `notes-panel__note--${s.emptyHighlight.color}`,
                    "notes-panel__note--empty",
                    { "notes-panel__note--error": !s.activeNoteFocused }
                  ]]),
                  tabindex: "0",
                  id: "hl-item--empty",
                  onFocusout: t[0] || (t[0] = (...n) => o.onFocusOut && o.onFocusOut(...n))
                }, [
                  (l(), r(A, c({ ...e.$attrs, ...e.$props }, {
                    "open-in-edit-mode": !0,
                    "is-disabled": s.noteLoading,
                    note: s.emptyHighlight.note,
                    "active-note": s.activeNote,
                    "active-note-focused": s.activeNoteFocused,
                    onNoteDelete: o.onNoteDelete,
                    onHighlightColorChange: o.onHighlightColorChange,
                    onNoteUpdateData: o.onNoteUpdateData,
                    onNoteTextChanged: o.onNoteTextChanged,
                    key: `${s.emptyHighlight.color}-empty-${s.updateCounter}`,
                    ref: "newNoteforHighlight"
                  }), null, 16, ["is-disabled", "note", "active-note", "active-note-focused", "onNoteDelete", "onHighlightColorChange", "onNoteUpdateData", "onNoteTextChanged"]))
                ], 34)) : x("", !0),
                (l(!0), u(C, null, U(o.filteredHighlights, (n) => {
                  var b, _, y, k;
                  return l(), u(C, null, [
                    (b = n.note) != null && b.id ? (l(), u("li", {
                      class: w(["notes-panel__note", [
                        `notes-panel__note--${n.color}`,
                        { "notes-panel__note--active": ((_ = s.activeNote) == null ? void 0 : _.id) === ((y = n.note) == null ? void 0 : y.id) },
                        { "notes-panel__note--error": !s.activeNoteFocused && s.editMode }
                      ]]),
                      "data-note-id": (k = n.note) == null ? void 0 : k.id,
                      "data-highlight-id": n.id,
                      key: n.id,
                      tabindex: "0",
                      id: `hl-item--${n.id}`,
                      onFocusin: (v) => o.onFocusIn(v, n),
                      onFocusout: t[1] || (t[1] = (...v) => o.onFocusOut && o.onFocusOut(...v))
                    }, [
                      (l(), r(A, c({ ...e.$attrs, ...e.$props }, {
                        note: n.note,
                        "active-note": s.activeNote,
                        "active-note-focused": s.activeNoteFocused,
                        "is-disabled": s.noteLoading,
                        "note-saved": s.noteSaved,
                        onCancelEdit: o.onCancelEdit,
                        onEditMode: o.onEditMode,
                        onNoteDelete: o.onNoteDelete,
                        onHighlightColorChange: o.onHighlightColorChange,
                        onNoteUpdateData: o.onNoteUpdateData,
                        onNoteTextChanged: o.onNoteTextChanged,
                        key: `note--${n.note.id}-${n.color}-${s.updateCounter}`
                      }), null, 16, ["note", "active-note", "active-note-focused", "is-disabled", "note-saved", "onCancelEdit", "onEditMode", "onNoteDelete", "onHighlightColorChange", "onNoteUpdateData", "onNoteTextChanged"]))
                    ], 42, te)) : x("", !0)
                  ], 64);
                }), 256))
              ])
            ])) : (l(), u("div", ie, [
              a("img", {
                class: "notes-panel__avatar",
                src: i.avatarPath || `${s.cStatic}img/public/2024/avatars/${s.avatarArt}.png`,
                alt: ""
              }, null, 8, oe),
              a("h3", se, N(e.$t("It looks you don't have any notes added yet.")), 1),
              a("p", ne, N(e.$t("Highlight text on the page to add your first note or add a note to an existing highlight.")), 1)
            ]))
          ])
        ]),
        _: 1
      }, 8, ["aria-label", "first-focus-id", "is-open", "mobileThreshold", "style", "onTogglePanel", "disable-close"])
    ]),
    f(M, {
      class: "notes-panel__confirmation-modal",
      ref: "confirmModal",
      size: "s",
      onClosedDialog: o.onDialogClosed
    }, {
      header: p(() => [
        a("h3", le, N(o.modalHeader), 1)
      ]),
      content: p(() => [
        a("p", he, N(o.modalContent), 1)
      ]),
      "actions-row": p(() => [
        f(d, {
          onClick: o.cancelAction,
          text: e.$t("Cancel"),
          size: "l"
        }, null, 8, ["onClick", "text"]),
        f(d, {
          onClick: t[2] || (t[2] = (n) => o.modalConfirmAction(s.activeNote)),
          text: o.modalConfirmActionText,
          size: "l",
          type: "ghost",
          "data-click-type": "TTS Notes Panel",
          "data-click-name": o.modalConfirmActionText
        }, null, 8, ["text", "data-click-name"])
      ]),
      _: 1
    }, 8, ["onClosedDialog"])
  ], 64);
}
const Ne = /* @__PURE__ */ G(H, [["render", ae]]);
export {
  Ne as default
};
